import { useEffect } from 'react';

export const useOutsideClick = (id: string, callback: (props?: any) => void) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const mouseEventsContainer = document.getElementById(
        `mouse-events-container-${id}`
      );

      if (
        !mouseEventsContainer?.contains(event.target as any) &&
        event.target !== mouseEventsContainer
      ) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
};
